import PropTypes from 'prop-types';

export const EnvKeys = ['prod', 'preprod', 'uat', 'sit'];
export const EnvPropTypes = PropTypes.oneOf(EnvKeys);

export const EnvKeysPropTypes = PropTypes.shape({
  prod: PropTypes.string,
  preprod: PropTypes.string,
  sit: PropTypes.string,
  uat: PropTypes.string,
  default: PropTypes.string
});

export const ExamplesPropTypes = PropTypes.shape({
  type: PropTypes.string,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  urls: EnvKeysPropTypes,
  imgCssClass: PropTypes.string,
  screenReader: PropTypes.shape({
    description: PropTypes.string,
    label: PropTypes.string
  })
});
